import { render, staticRenderFns } from "./AllQuestions.vue?vue&type=template&id=ee4364e2"
import script from "./AllQuestions.vue?vue&type=script&lang=js"
export * from "./AllQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports